import {
  CONSTRUCTION_YEAR_LIMIT_SUPER,
  CabinStandards,
  MAX_GROSS_AREA,
} from "./cabinConstants";

import { formBooleanToBoolean } from "Utils/formUtils";
import { CabinPriceFormValues } from "./ProductPrice/cabinProductPriceInterfaces";

export const isGrossAreaInvalid = (grossArea: string | undefined): boolean =>
  grossArea ? parseInt(grossArea) > MAX_GROSS_AREA : false;

export const tooOldForSuper = (constructionYear: number): boolean =>
  constructionYear < CONSTRUCTION_YEAR_LIMIT_SUPER;

export const hasCabinContentsInsurance = (
  formValues: CabinPriceFormValues,
): boolean => formBooleanToBoolean(formValues.addContentsInsurance);

export const isStandardHigh = (value?: string): boolean =>
  value === CabinStandards.VERY_HIGH;

export const isStandardLow = (value?: string): boolean =>
  value === CabinStandards.LOWER;
